import * as CloudAdmin from 'constants/cloud-admin';

export interface ModalPosition {
  top: number;
  right: number;
}

export interface SelectedToolButtonAction {
  type: string;
  selectedToolName?: string;
}

export interface ClearToolSelectionAction {
  type: string;
}

export interface ShowModalAction {
  type: string;
  modalType?: string;
  feature: string;
}

export interface HideModalAction {
  type: string;
}

export interface PositionModalAction {
  type: string;
  modalPosition?: ModalPosition;
}

export interface SortByColumnAction {
  type: string;
  sortByColumn?: string;
}

export interface ClearSortByColumnAction {
  type: string;
}

export interface ColumnSortClicksAction {
  type: string;
  clicks?: number;
}

export interface FilterByStatusAction {
  type: string;
  filterByStatus?: string;
}

export interface ClearFilterByStatusAction {
  type: string;
}

export interface FilterByValueAction {
  type: string;
  filterByValue?: string;
}

export interface ClearFilterByValueAction {
  type: string;
}

export interface UpdateRowsSelectedAction {
  type: string;
  rowsSelectedIdsArray?: string[];
}

export interface ClearRowsSelectedAction {
  type: string;
}

export function selectedToolButton(selectedToolName?: string): SelectedToolButtonAction {
  return {
    type: CloudAdmin.TOOL_SELECTOR_ACTION_TYPES.SELECT_TOOL_BUTTON,
    selectedToolName,
  };
}
export function clearToolSelection(): ClearToolSelectionAction {
  return { type: CloudAdmin.TOOL_SELECTOR_ACTION_TYPES.CLEAR_TOOL_SELECTION };
}

export function showModal(modalType?: string, feature = ''): ShowModalAction {
  return { type: CloudAdmin.MODAL_ACTION_CONSTANTS.SHOWMODAL, modalType, feature };
}

export function hideModal(): HideModalAction {
  return { type: CloudAdmin.MODAL_ACTION_CONSTANTS.HIDEMODAL };
}

export function positionModal(positionObject?: ModalPosition): PositionModalAction {
  return {
    type: CloudAdmin.MODAL_ACTION_CONSTANTS.POSITION_MODAL,
    modalPosition: positionObject,
  };
}

export function sortByColumn(value?: string): SortByColumnAction {
  return { type: CloudAdmin.USER_SORT.SORT_BY_COLUMN, sortByColumn: value };
}

export function clearSortByColumn(): ClearSortByColumnAction {
  return { type: CloudAdmin.USER_SORT.CLEAR_SORT_BY_COLUMN };
}

export function columnSortClicks(clicks?: number): ColumnSortClicksAction {
  return { type: CloudAdmin.USER_SORT.COLUMN_SORT_CLICKS, clicks };
}

export function filterByStatus(value?: string): FilterByStatusAction {
  return { type: CloudAdmin.USER_FILTER.FILTER_BY_STATUS, filterByStatus: value };
}

export function clearFilterByStatus(): ClearFilterByStatusAction {
  return { type: CloudAdmin.USER_FILTER.CLEAR_FILTER_BY_STATUS };
}

export function filterByValue(value?: string): FilterByValueAction {
  return { type: CloudAdmin.USER_FILTER.FILTER_BY_VALUE, filterByValue: value };
}

export function clearFilterByValue(): ClearFilterByValueAction {
  return { type: CloudAdmin.USER_FILTER.CLEAR_FILTER_BY_VALUE };
}

export function updateRowsSelected(rowsSelectedIdsArray?: string[]): UpdateRowsSelectedAction {
  return { type: CloudAdmin.ROWS.ROWS_SELECTED, rowsSelectedIdsArray };
}

export function clearRowsSelected(): ClearRowsSelectedAction {
  return { type: CloudAdmin.ROWS.CLEAR_ROWS_SELECTED };
}
